// languages.js
const languages = [
    { code: 'en', name: 'English' },
    { code: 'es', name: 'Spanish' },
    { code: 'de', name: 'German' },
    { code: 'fr', name: 'French' },
    { code: 'uk', name: 'Ukrainian' },
  ];
  
  export default languages;
  
